import { render, staticRenderFns } from "./CardLead.vue?vue&type=template&id=28f4bf17&lang=html&"
import script from "./CardLead.vue?vue&type=script&lang=js&"
export * from "./CardLead.vue?vue&type=script&lang=js&"
import style0 from "./CardLead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports